<div class="parallax-container">
  @for (card of projects; track $index) {
    <div class="parallax-el">
      <div class="card"
           [class.visible]="isVisible($index)"
           appParallax  appVisibilityObserver
           (visible)="onCardVisibilityChange($index, $event)"
      >

        <div class="content">
          <div class="content--text">
            <div class="title">
              <span class="group">{{$index + 1}}. {{ card.group }}</span>
              <h3>{{ card.title }}</h3>
            </div>
            <p>{{ card.description }}
            </p>
            <div class="action">
              <button mat-raised-button (click)="openDetailsDialog(card)">Learn more</button>
            </div>
          </div>
          <div class="screen">
            <video class="screen--clip"
                   appAutoplayOnView
                   muted
                   loop
                   [attr.src]="card.videoUrl">
            </video>
          </div>

        </div>
      </div>
    </div>
  }
</div>




